const DEFAULT_MAX_FILE_SIZE_MB = 1;

export function getMaxFileSizeMB(): number {
  const stored = sessionStorage.getItem('max_file_size_mb') || localStorage.getItem('max_file_size_mb');
  if (stored) {
    const parsed = Number(stored);
    if (!isNaN(parsed) && parsed > 0) return parsed;
  }
  return DEFAULT_MAX_FILE_SIZE_MB;
}
